import { logout } from "@services/krent.service";
import { useSessionStorage } from "../../../hooks";
import Logo from "@shared/Logo";
import React, { useState, useEffect } from "react";
import { Navbar, NavDropdown } from "react-bootstrap";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { removeCookie } from "@utils/cookies";
import { GetStartedModal } from "../../GetStartedModal";
import { LoginModal } from "../../LoginModal";

interface NavItemProps {
  to: string | { pathname: string };
  children: React.ReactNode;
  target?: string;
}
interface NavDropdownItemProps {
  to: string;
  children: React.ReactNode;
  setPage: any;
}

interface NavItemProps {
  to: string | { pathname: string };
  children: React.ReactNode;
  target?: string;
}

const NavItem: React.FC<NavItemProps> = ({ to, children, target }) => (
  <li className="nav-item">
    {typeof to === "string" ? (
      <NavLink className="nav-link px-lg-3" to={to}>
        {children}
      </NavLink>
    ) : (
      <a
        className="nav-link px-lg-3"
        href={to.pathname}
        target={target}
        rel={target === "_blank" ? "noreferrer" : undefined}
      >
        {children}
      </a>
    )}
  </li>
);

const NavDropdownItem: React.FC<NavDropdownItemProps> = ({
  to,
  children,
  setPage,
}) => {
  const handleClick = () => {
    setPage(1);
  };

  return (
    <div className="dropdown-item">
      <NavLink
        to={to}
        className="nav-link text-decoration-none"
        onClick={handleClick}
      >
        {children}
      </NavLink>
    </div>
  );
};

export const NavBarMenu = ({ setPage }: any) => {
  const [user, setUser] = useSessionStorage("user", {});
  const [showGetStartedModal, setShowGetStartedModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [shouldOpenSignup, setShouldOpenSignup] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("auth") !== "login") return;
    setShowLoginModal(true);
    params.delete("auth");
    const search = params.toString();
    navigate(
      `${location.pathname}${search ? `?${search}` : ""}${location.hash}`,
      {
        replace: true,
        state: location.state,
      },
    );
  }, [location, navigate]);

  // Handle modal switching
  useEffect(() => {
    if (shouldOpenSignup) {
      setShowLoginModal(false);
      setTimeout(() => {
        setShowGetStartedModal(true);
        setShouldOpenSignup(false);
      }, 150);
    }
  }, [shouldOpenSignup]);

  const handleLogout = () => {
    let abortController = new AbortController();
    logout(abortController.signal)
      .then(() => {
        setUser({});
        window && window.sessionStorage.clear();
        localStorage.removeItem("dontShowConversationModal");
        removeCookie("1Q_SPA");
        navigate("/", { replace: true, state: { from: location } });
      })
      .catch((e) => {
        console.log(e);
      });
  };
  return (
    <>
      <Navbar bg="white" expand="lg" className="fixed-top shadow-sm py-2">
        <div className="container py-2 py-md-0 d-flex flex-row justify-content-between align-items-center ">
          <div className="d-flex flex-row justify-content-between align-items-center col-12 col-lg-auto">
            <Navbar.Brand>
              <Link to="/">
                <Logo />
              </Link>
            </Navbar.Brand>
            <div className="d-flex align-items-center gap-3 gap-2">
              {/* <Link
                className="nav-link fw-bold py-2 d-lg-none text-center fs-14 d-lg-inline-block"
                to="/sign-in/"
              >
                {user.id ? "My Profile" : "Sign In"}
              </Link> */}
              {!user.id && (
                <button
                  className="btn btn-custom-primary fs-10 text-nowrap d-lg-none fw-600 py-2 px-3 rounded-pill w-md-25 mb-1"
                  onClick={() => setShowGetStartedModal(true)}
                >
                  Get Started
                </button>
              )}
              {user.id && (
                <Link
                  className="nav-link fw-bold py-2 d-lg-none text-center text-nowrap fs-10 btn btn-link"
                  to="/profile"
                >
                  My Profile
                </Link>
              )}

              <Navbar.Toggle className="border-0" />
            </div>
          </div>
          <Navbar.Collapse
            id="basic-navbar-nav"
            className="justify-content-center fs-14 fw-600"
          >
            <ul className="navbar-nav mr-auto align-items-lg-center gap-lg-5">
              <NavItem to="/">Home</NavItem>

              {/* <li>
                <NavDropdown
                  title="For Sale"
                  id="basic-nav-dropdown"
                  className="custom-dropdown"
                >
                  <NavDropdownItem
                    to="/property-for-sale/house"
                    setPage={setPage}
                  >
                    House for sale
                  </NavDropdownItem>
                  <NavDropdownItem
                    to="/property-for-sale/land"
                    setPage={setPage}
                  >
                    Land for sale
                  </NavDropdownItem>
                  <NavDropdownItem
                    to="/property-for-sale/apartment"
                    setPage={setPage}
                  >
                    Flats & Apartments for Sale
                  </NavDropdownItem>
                  <NavDropdownItem
                    to="/property-for-sale/commercial"
                    setPage={setPage}
                  >
                    Commercial Property for Sale
                  </NavDropdownItem>
                  <NavDropdownItem to="/property-for-sale" setPage={setPage}>
                    All Property for sale
                  </NavDropdownItem>
                </NavDropdown>
              </li>
              */}
              <li>
                <NavDropdown
                  title="Rent"
                  id="basic-nav-dropdown"
                  className="custom-dropdown"
                >
                  <NavDropdownItem to="/property-for-rent" setPage={setPage}>
                    All Properties for rent
                  </NavDropdownItem>
                  {/* <NavDropdownItem
                    to="/property-for-rent/apartment"
                    setPage={setPage}
                  >
                    Flats & Apartments for Rent
                  </NavDropdownItem> */}
                </NavDropdown>
              </li>
              <li>
                <NavDropdown
                  title="Shortlet"
                  id="basic-nav-dropdown"
                  className="custom-dropdown"
                >
                  <NavDropdownItem
                    to="/property-for-shortlet/in/lekki"
                    setPage={setPage}
                  >
                    Shortlet in Lekki
                  </NavDropdownItem>
                  <NavDropdownItem
                    to="/property-for-shortlet/in/lagos"
                    setPage={setPage}
                  >
                    Shortlet in Lagos
                  </NavDropdownItem>
                  <NavDropdownItem
                    to="/property-for-shortlet/in/abuja"
                    setPage={setPage}
                  >
                    Shortlet in Abuja
                  </NavDropdownItem>
                  <NavDropdownItem
                    to="/property-for-shortlet"
                    setPage={setPage}
                  >
                    All Shortlet Properties
                  </NavDropdownItem>
                </NavDropdown>
              </li>
              <NavItem to="/shortlet">Explore</NavItem>

              {/* <NavItem
                to={{ pathname: "https://blog.krent.space/area-guide" }}
                target="_blank"
              >
                Area Guide
              </NavItem>
              <NavItem
                to={{ pathname: "https://blog.krent.space/" }}
                target="_blank"
              >
                Krent Blog
              </NavItem>
              <NavItem to={{ pathname: "/developer-listings" }}>
                Developer Listings
              </NavItem> */}

              <li className="nav-item">
                {!user.id ? (
                  <button
                    className="nav-link d-lg-none btn btn-link"
                    onClick={() => setShowLoginModal(true)}
                  >
                    Sign In
                  </button>
                ) : (
                  <button
                    className="nav-link text-red d-lg-none bg-white"
                    onClick={handleLogout}
                  >
                    Sign Out
                  </button>
                )}
              </li>
            </ul>
          </Navbar.Collapse>
          <div className="navbar-nav d-flex justify-content-center align-items-center">
            {!user.id && (
              <button
                className="btn btn-custom-primary d-none d-lg-inline-block fs-12 fw-600 py-2 px-4 rounded-3"
                onClick={() => setShowGetStartedModal(true)}
              >
                Get Started
              </button>
            )}
            {user.id && (
              <Link
                className="nav-link fw-bold py-2 d-none text-center fs-14 d-lg-inline-block btn btn-link text-decoration-none"
                to="/profile"
              >
                My Profile
              </Link>
            )}
          </div>
        </div>
      </Navbar>
      <GetStartedModal
        show={showGetStartedModal}
        onClose={() => setShowGetStartedModal(false)}
        onOpenLogin={() => {
          setShowGetStartedModal(false);
          setTimeout(() => {
            setShowLoginModal(true);
          }, 150);
        }}
      />
      <LoginModal
        show={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onOpenSignup={() => {
          setShouldOpenSignup(true);
        }}
      />
    </>
  );
};
